import React from 'react';
import { FjEditableInput } from '../primitives';

type DeviceNameProps = {
  value: string;
  onUpdate: (value: string) => void;
};

const validator = (value: string) => {
  if (value.length < 3) {
    return 'Device name must be at least 3 characters long';
  }
  return null;
};

const DeviceNameRenameable = ({ value, onUpdate }: DeviceNameProps) => (
  <FjEditableInput
    value={value}
    // FjEditableInput types onUpdate's arg as `unknown`; at runtime it is the string value
    onUpdate={(updated: unknown) => onUpdate(updated as string)}
    displayEditOnHover
    validator={validator}
  />
);

export default DeviceNameRenameable;
